import script from "./CrudRutinas.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudRutinas.vue?vue&type=script&setup=true&lang=js"

import "./CrudRutinas.vue?vue&type=style&index=0&id=51b7c760&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51b7c760"]])

export default __exports__